export default __webpack_public_path__ + "static/media/bl5.373528f8.png";